<template>
  <div>
    <b-card class="cardStyle">
      <b-button class="enrollment-card-button" disabled>
        <b-icon :icon="icon" :variant="color" scale="2"></b-icon>
      </b-button>
      <span class="enrollment-card-title text-nowrap">
        {{ title }}
        <div :class="'text-' + color + ' mt-2 enrollment-card-number'">
          {{ number }}
        </div>
      </span>
      <hr class="solid" />
      <div class="enrollment-card-details" v-if="infoText !== 'Discontinued'">
        {{ infoText }}:<strong> {{ source }}</strong>
      </div>
      <div class="enrollment-card-details" v-else>
        &nbsp;
      </div>
    </b-card>
  </div>
</template>

<script>
  export default {
    props: ['icon', 'color', 'title', 'number', 'infoText', 'source'],
  };
</script>

<style>
  .enrollment-card-button {
    background: #f4eff4 !important;
    border-radius: 16px;
    position: static;
    width: 4rem;
    height: 4rem;
    border: 0;
  }

  .enrollment-card-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    color: #6f6f6f;
    float: right;
  }

  .enrollment-card-number {
    font-weight: 500;
    font-size: 38px;
    line-height: 38px;
    text-align: right;
  }

  .enrollment-card-details {
    font-size: 12px;
    line-height: 16px;
    color: #6f6f6f;
    text-align: right;
  }
</style>
